import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRoute = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 6.00052C1 6.00052 4.22003 3.84191 6.5 4.00052C8.41847 4.13398 11 6.00052 11 6.00052",
		stroke: "#38B49E",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgRoute;
